import React from 'react';
import { motion } from 'framer-motion';
import SyncBars from './SyncBars';

// Consistent page-header band used across every routed page.
// The mono index + eyebrow is the recurring structural device.
export default function PageHeader({ index, eyebrow, title, accent, intro }) {
  return (
    <header className="relative overflow-hidden border-b border-line">
      <div className="absolute inset-0 bg-syncgrid pointer-events-none" />
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[640px] h-[320px] bloom rounded-full blur-3xl pointer-events-none" />

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="eyebrow text-purple-500">{index}</span>
            <span className="h-px w-8 bg-gradient-to-r from-purple-500 to-pink-500" />
            <span className="eyebrow">{eyebrow}</span>
            <SyncBars count={4} className="h-3 ml-1 opacity-80" />
          </div>

          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-strong leading-[1.04] max-w-3xl">
            {title} {accent && <span className="ink-grad">{accent}</span>}
          </h1>

          {intro && (
            <p className="mt-6 text-lg text-soft max-w-xl leading-relaxed">{intro}</p>
          )}
        </motion.div>
      </div>
    </header>
  );
}
